import { Copy, Sparkles, Shuffle } from "lucide-react";

export const MODES = [
  { id: "simple", icon: Copy, title: "Duplicazione semplice", badge: "Senza AI · 0 $",
    text: "Copia completa del sito. Sostituisci tu nome, contatti, immagini e altri dati: nessun costo AI." },
  { id: "same_sector", icon: Sparkles, title: "AI · stesso settore", badge: "AI · pochi centesimi",
    text: "L'AI adatta testi, brand, contatti, colori, font e immagini. Struttura, pagine e funzionalità restano identiche." },
  { id: "new_sector", icon: Shuffle, title: "AI · nuovo settore", badge: "AI · come una generazione",
    text: "L'AI riprogetta sezioni, pagine, contenuti e funzionalità per il nuovo settore, con lo stesso livello qualitativo." },
];

export default function ModeStep({ mode, setMode }) {
  return (
    <div className="grid gap-3" role="radiogroup" data-testid="dup-mode-step">
      {MODES.map(({ id, icon: Icon, title, text, badge }) => (
        <button key={id} type="button" role="radio" aria-checked={mode === id} onClick={() => setMode(id)} data-testid={`dup-mode-${id}`}
          className={`flex gap-4 rounded-xl border p-4 text-left transition-[border-color,background-color] ${mode === id ? "border-sky-500 bg-sky-50/50 ring-1 ring-sky-500" : "border-slate-200 hover:border-slate-300 bg-white"}`}>
          <span className={`h-10 w-10 shrink-0 rounded-lg flex items-center justify-center ${mode === id ? "bg-navy-900 text-sky-300" : "bg-slate-100 text-slate-600"}`}><Icon size={18} /></span>
          <span className="min-w-0">
            <span className="flex flex-wrap items-center gap-2">
              <span className="font-semibold text-slate-900">{title}</span>
              <span className="text-[10px] uppercase tracking-wider rounded-full bg-slate-100 px-2 py-0.5 text-slate-600">{badge}</span>
            </span>
            <span className="mt-1 block text-sm text-slate-600">{text}</span>
          </span>
        </button>
      ))}
      <p className="text-xs text-slate-500">La duplicazione crea sempre un nuovo progetto indipendente: l'originale non viene modificato.</p>
    </div>
  );
}
